/*
 * Copyright (c) 2026 Gabriele Bonora. Tutti i diritti riservati.
 *
 * Software proprietario. Nessuna licenza d'uso, copia, modifica o distribuzione
 * e' concessa in assenza di autorizzazione scritta del titolare dei diritti.
 * Vedere il file LICENSE nella radice del progetto.
 */
import { useQuery } from '@tanstack/react-query';
import { authAPI } from '../api/auth';

/*
 * Il profilo com'e' ADESSO sul server, non com'era al login.
 *
 * L'utente in AuthContext arriva da `tce_user` in localStorage, scritto il giorno
 * dell'ultimo login: chi e' entrato prima che esistesse `tipo_cliente` ce l'ha
 * senza, e la voce Inventario non gli comparirebbe finche' non rifa' il login.
 * Una chiamata sola, tenuta in cache cinque minuti, toglie il problema.
 */
export function useProfilo() {
  return useQuery({
    queryKey: ['profilo'],
    queryFn: () => authAPI.me(),
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });
}

// L'inventario esiste solo per i clienti azienda: il privato non ha magazzino.
export function useIsAzienda() {
  const { data } = useProfilo();
  return data?.tipo_cliente === 'azienda';
}
